import {createRouter, createWebHistory} from 'vue-router';

const routes = [
    {
        path: '/',
        redirect: {
            name: "login"
        }
    },
    {
        path: '/index.html',
        redirect: {
            name: "login"
        }
    },
    {
        path: '/iduy-login',
        name: 'iduy-login',
        component: () => import('./pages/LoginIdUy.vue'),
    },
    {
        path: '/iduy-logout',
        name: 'iduy-logout',
        component: () => import('./pages/Login.vue'),
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('./pages/Login.vue'),
    },
    {
        path: '/beneficios',
        name: 'beneficios',
        exact: true,
        component: () => import('./components/Beneficios.vue'),
        meta: {
            breadcrumb: [{ parent: 'Beneficios', label: 'Beneficios' }],
        },
        props: true
    },
    {
        path: '/postulaciones',
        name: 'postulaciones',
        component: () => import('./pages/NotFound.vue'),
        props: true
    },
    {
        path: '/tramites',
        name: 'tramites',
        component: () => import('./components/TramitesList.vue'),
        meta: {
            breadcrumb: [{ parent: 'UI Kit', label: 'Trámites en línea' }],
        },
        props: true
    },
    {
        path: '/datospersonales',
        name: 'Datos personales',
        component: () => import('./pages/DatosPersonales.vue'),
        props: true,
        meta: {
            breadcrumb: [{ parent: 'Pages', label: 'Datos Personales' }],
        },
    },
    {
        path: '/address',
        name: 'Dirección',
        component: () => import('./pages/Address.vue'),
        meta: {
            breadcrumb: [{ parent: 'Datos personales', label: 'Dirección' }],
        },
    },
    {
        path: '/email',
        name: 'Correo electrónico',
        component: () => import('./pages/Email.vue'),
        meta: {
            breadcrumb: [{ parent: 'Datos personales', label: 'Correo electrónico' }],
        },
    },
    {
        path: '/AfamTuApp',
        name: 'Postulación para pago a través de TuApp',
        component: () => import('./pages/AfamTuApp.vue'),
        meta: {
            breadcrumb: [{ parent: 'Servicios', label: 'Pago Asignación por TuApp' }],
        },
        children: [
            {
                path: '',
                name:'telefono',
                component: () => import('./components/Telefono.vue'),
                props: true,
            },
            {
                path: '/AfamTuApp/verificar',
                name:'vivienda',
                component: () => import('./components/Verificar.vue'),
                props: true,
            },
            {
                path: '/AfamTuApp/postular',
                name:'postular',
                component: () => import('./components/Postular.vue'),
                props: true,
            },
            {
                path: '/AfamTuApp/confirmacion',
                name:'confirmacion',
                component: () => import('./components/Confirmacion.vue'),
                props: true,
            },
            ]
    },
    {
        path: '/Asistentes',
        name: 'Asistentes Personales',
        component: () => import('./pages/Asistentes.vue'),
        props:true,
        meta: {
            breadcrumb: [{ parent: 'Pages', label: 'Asistentes Personales' }],
        },
        children: [
            {
                path: '',
                name:'telefono AP',
                component: () => import('./components/TelefonoAP.vue'),
                props: true,
            },
            {
                path: '/Asistentes/verificar',
                name:'verificar AP',
                component: () => import('./components/VerificarAP.vue'),
                props: true,
            },
            {
                path: '/Asistentes/domicilio',
                name:'domicilio AP',
                component: () => import('./components/DomicilioAP.vue'),
                props: true,
            },
            {
                path: '/Asistentes/ratificar',
                name:'ratificar AP',
                component: () => import('./components/RatificarAP.vue'),
                props: true,
            },
            {
                path: '/Asistentes/confirmacion',
                name:'confirmacion AP',
                component: () => import('./components/ConfirmacionAP.vue'),
                props: true,
            },
            ]
    },
    {
        path: '/DJ',
        name: 'Declaración Jurada',
        component: () => import('./pages/DJ.vue'),
        meta: {
            breadcrumb: [{ parent: 'Servicios', label: 'Declaración Jurada' }],
        },
    },
    {
        path: '/CiudadUniversitaria',
        name: 'Ciudad Universitaria',
        component: () => import('./pages/CiudadUniversitaria.vue'),
        props: true,
        meta: {
            breadcrumb: [{ parent: 'Servicios', label: 'Ciudad Universitaria' }],
        },
    },
    {
        path: '/Comedores',
        name: 'Alimentación',
        component: () => import('./pages/Comedores.vue'),
        props: true,
        meta: {
            breadcrumb: [{ parent: 'Servicios', label: 'Alimentación' }],
        },
        children: [
            {
                path: '',
                name:'nucleoC',
                component: () => import('./components/NucleoC.vue'),
                props: true,
            },
            {
                path: '/Comedores/ingresos',
                name:'ingresosC',
                component: () => import('./components/IngresosC.vue'),
                props: true,
            },
            {
                path: '/Comedores/telefono',
                name:'telefonoC',
                component: () => import('./components/TelefonoC.vue'),
                props: true,
            },
            {
                path: '/Comedores/verificar',
                name:'verificarC',
                component: () => import('./components/VerificarC.vue'),
                props: true,
            },
            {
                path: '/Comedores/cocina',
                name:'cocinaC',
                component: () => import('./components/CocinaC.vue'),
                props: true,
            },
            {
                path: '/Comedores/postulantes',
                name:'postulantesC',
                component: () => import('./components/PostulantesC.vue'),
                props: true,
            },
            {
                path: '/Comedores/lugar',
                name:'lugarC',
                component: () => import('./components/LugarC.vue'),
                props: true,
            },
            {
                path: '/Comedores/confirmacion',
                name:'confirmacionC',
                component: () => import('./components/ConfirmacionC.vue'),
                props: true,
            },
        ]
    },

    {
        path: '/SaldoTUS',
        name: 'Saldo TUS',
        component: () => import('./pages/SaldoTUS.vue'),
        meta: {
            breadcrumb: [{parent: 'Información', label: 'Saldo TUS'}]
        },
    },
    {
        path: '/Chat',
        name: 'Chat',
        component: () => import('./pages/Chat.vue'),
        meta: {
            breadcrumb: [{parent: 'Información', label: 'Chat'}]
        },
    },
    {
        path: '/Comedores',
        name: 'Alimentación',
        component: () => import('./pages/Comedores.vue'),
        props: true,
        meta: {
            breadcrumb: [{ parent: 'Servicios', label: 'Alimentación' }],
        },
        children: [
            {
                path: '',
                name:'nucleoC',
                component: () => import('./components/NucleoC.vue'),
                props: true,
            },
            {
                path: '/Comedores/ingresos',
                name:'ingresosC',
                component: () => import('./components/IngresosC.vue'),
                props: true,
            },
            {
                path: '/Comedores/telefono',
                name:'telefonoC',
                component: () => import('./components/TelefonoC.vue'),
                props: true,
            },
            {
                path: '/Comedores/verificar',
                name:'verificarC',
                component: () => import('./components/VerificarC.vue'),
                props: true,
            },
            {
                path: '/Comedores/cocina',
                name:'cocinaC',
                component: () => import('./components/CocinaC.vue'),
                props: true,
            },
            {
                path: '/Comedores/postulantes',
                name:'postulantesC',
                component: () => import('./components/PostulantesC.vue'),
                props: true,
            },
            {
                path: '/Comedores/lugar',
                name:'lugarC',
                component: () => import('./components/LugarC.vue'),
                props: true,
            },
            {
                path: '/Comedores/confirmacion',
                name:'confirmacionC',
                component: () => import('./components/ConfirmacionC.vue'),
                props: true,
            },
        ]
    },
    {
        path: '/Garrafas',
        name: 'Subsidio Garrafas',
        component: () => import('./pages/Garrafas.vue'),
        props: true,
        meta: {
            breadcrumb: [{ parent: 'Servicios', label: 'Subsidio Garrafas' }],
        },
        children: [
            {
                path: '',
                name:'telefonoG',
                component: () => import('./components/TelefonoG.vue'),
                props: true,
            },
            {
                path: '/Garrafas/verificar',
                name:'verificarG',
                component: () => import('./components/VerificarG.vue'),
                props: true,
            },
            {
                path: '/Garrafas/departamento',
                name:'departamentoG',
                component: () => import('./components/DepartamentoG.vue'),
                props: true,
            },
            {
                path: '/Garrafas/confirmacion',
                name:'confirmacionG',
                component: () => import('./components/ConfirmacionG.vue'),
                props: true,
            },
        ]
    },
    /* {
        path: '/AfamTuApp',
        name: 'Postulación para pago a través de TuApp',
        component: () => import('./pages/AfamTuApp.vue'),
        props:true,
        meta: {
            breadcrumb: [{ parent: 'Pages', label: 'AFAM-PE / IVA Personalizado' }],
        },
        children: [
            {
                path: '',
                name:'telefono',
                component: () => import('./components/Telefono.vue'),
                props: true,
            },
            {
                path: '/AfamTuApp/verificar',
                name:'vivienda',
                component: () => import('./components/Verificar.vue'),
                props: true,
            },
            {
                path: '/AfamTuApp/postular',
                name:'postular',
                component: () => import('./components/Postular.vue'),
                props: true,
            },
            {
                path: '/AfamTuApp/confirmacion',
                name:'confirmacion',
                component: () => import('./components/Confirmacion.vue'),
                props: true,
            },
            ]
    },
    {
        path: '/DJ',
        name: 'Declaración Jurada',
        component: () => import('./pages/DJ.vue'),
        props: true,
        meta: {
            breadcrumb: [{ parent: 'Pages', label: 'Declaración Jurada' }],
        },
    }, */
    {
        path: '/inbox',
        name: 'inbox',
        component: () => import('./pages/NotFound.vue'),
        props: true
    },
    {
        path: '/error',
        name: 'error',
        component: () => import('./pages/Error.vue'),
        props: true
    },
    {
        path: '/notfound',
        name: 'notfound',
        component: () => import('./pages/NotFound.vue'),
        props: true
    },
    {
        path: '/access',
        name: 'access',
        component: () => import('./pages/Access.vue'),
        props: true
    },
    {
        path: '/logout',
        name: 'logout',
        component: () => import('./pages/Login.vue'),
    },
    {
        path: '/offline',
        name: 'offline',
        component: () => import('./pages/Offline.vue'),
        props: true
    },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior () {
        return { left: 0, top: 0 };
    }
});

export default router;